import { useState } from "react";
import { describe } from "../lib/instruments";

/** A ticker you can interrogate.
 *
 * Hover gives the one-liner (desktop). Tap opens it (phones have no hover, and
 * that is where Alan reads the book). Unknown symbols render as plain text
 * with no affordance rather than an empty popover promising an explanation
 * that isn't there.
 */
export default function Ticker({ symbol, className = "" }: { symbol: string; className?: string }) {
  const [open, setOpen] = useState(false);
  const d = describe(symbol);

  if (!d) return <span className={className}>{symbol}</span>;

  return (
    <span className="relative inline-block">
      <button
        type="button"
        title={`${d.name} — ${d.what}${d.note ? ` (${d.note})` : ""}`}
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        className={`${className} border-b border-dotted border-slate-600 hover:border-gold cursor-help`}
      >
        {symbol}
      </button>
      {open && (
        <span
          role="tooltip"
          // Fixed width and normal-case, because these drop into headings that
          // are uppercase and monospaced — inheriting either makes prose
          // unreadable.
          className="absolute z-30 left-0 top-full mt-1 w-64 p-2 rounded-lg border border-edge
                     bg-ink shadow-lg text-left normal-case font-sans tracking-normal
                     text-xs text-slate-300 whitespace-normal"
          onClick={(e) => e.stopPropagation()}
        >
          <span className="block font-semibold text-slate-100">{d.name}</span>
          <span className="block mt-0.5">{d.what}</span>
          {d.note && <span className="block mt-1 text-gold">{d.note}</span>}
        </span>
      )}
    </span>
  );
}
